"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var financialLecture_1 = require("../../model/financialLecture");
var service_1 = require("../../../library/base/service");
var QueryList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(QueryList, _super);
    function QueryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '金融微讲堂列表';
        _this.code = '101138';
        _this.desc = "\u91D1\u878D\u5FAE\u8BB2\u5802\u5217\u8868";
        _this.requestParams = new financialLecture_1.QueryListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return QueryList;
}(service_1.BaseService));
exports.QueryList = QueryList;
//# sourceMappingURL=queryList.js.map